/**
 * 静态官网路由 - 无需权限校验
 */

import Home from '@/pages/Home';
import Resources from '@/pages/Resources';
import ContactUs from '@/pages/ContactUs';
import AboutUs from '@/pages/AboutUs';
import Products from '@/pages/Products';
import ProductsCollections from '@/pages/Products/Collections';
import ProductsCustom from '@/pages/Products/Custom';
import ProductsDetail from '@/pages/Products/Detail';

// 不配置authName, 代表无权限即可访问
export default [
  {
    path: '/',
    i18nTitle: 'Home',
    component: <Home />,
  },
  {
    path: '/products',
    i18nTitle: 'Products',
    component: <Products />,
    children: [
      {
        i18nTitle: 'Custom',
        path: 'custom',
        component: <ProductsCustom />,
        meta: {
          hideInMenu: true,
        },
      },
      {
        i18nTitle: 'Collection',
        path: ':collectionKey',
        component: <ProductsCollections />,
        meta: {
          hideInMenu: true,
        },
        children: [
          {
            i18nTitle: 'Product',
            path: ':productKey',
            component: <ProductsDetail />,
            meta: {
              hideInMenu: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/resources',
    i18nTitle: 'Resources',
    component: <Resources />,
  },
  {
    path: '/contact-us',
    i18nTitle: 'Contact Us',
    component: <ContactUs />,
  },
  {
    path: '/about-us',
    i18nTitle: 'About Us',
    component: <AboutUs />,
  },
];
